// Pickup display: renders various pickup UI elements such as the header pickup handle and the cart pickup-info box
(function () {
  // Render the header pickup handle from the current selection.
  function renderPickupHandle() {
    const pickup = window.PickupSelection.get();
    const labels = (window.PickupContext && window.PickupContext.labels) || {};

    let selectedDay;
    let title;
    let label;
    if (pickup.locationName && pickup.day) {
      selectedDay = pickup.day;
      label = pickup.locationName;
    } else if (pickup.locationName) {
      title = labels.selectDay || 'Select a pickup day';
      label = pickup.locationName;
    } else {
      title = labels.pickingUp || '';
      label = labels.selectStore || '';
    }

    document.querySelectorAll('[data-store-title]').forEach((el) => {
      if (!selectedDay) {
        el.textContent = title;
        return;
      }
      // The narrow mobile row drops the weekday so long location names keep their space.
      el.textContent = el.hasAttribute('data-hide-weekday')
        ? window.DateUtils.formatMonthDay(selectedDay)
        : window.DateUtils.formatWeekdayMonthDay(selectedDay);
    });
    document.querySelectorAll('[data-store-label]').forEach((el) => {
      el.textContent = label;
    });
  }

  // Seed the cart's pickup location from a saved handle, resolving its name from the modal.
  async function writeLocationToCart(storeHandle) {
    const name = window.PickupModals.getLocationName(storeHandle);
    if (!name) return;
    await window.PickupSelection.setLocation({
      handle: storeHandle,
      locationName: name,
    }).catch((err) => console.error('Error writing pickup location to cart:', err));
  }

  // Clear the selected location if it doesn't correspond to a currently available location
  async function clearInvalidPickup() {
    const pickup = window.PickupSelection.get();
    if (pickup.handle && !window.PickupModals.getLocationName(pickup.handle)) {
      await window.PickupSelection.clear();
    }
  }

  // On load, seed the cart from the customer's preferred location when nothing is selected yet.
  async function loadSavedPickupInfo() {
    const pickup = window.PickupSelection.get();
    if (!pickup.handle) {
      const handle = window.PickupUserPreferences.getDefaultPickupHandle();
      if (handle) await writeLocationToCart(handle);
    }
  }

  // Update the cart-page pickup info panel (server-rendered in main-cart).
  // Scoped to `.cart__details` so header/dropdown markup cannot steal the update.
  function displayPickupInfo() {
    const pickupInfoEl = document.querySelector(
      '.cart__details #cart-pickup-info, .cart__details [data-cart-pickup-info]'
    );
    if (!pickupInfoEl) return;

    const pickup = window.PickupSelection.get();
    const pickupDate = pickup.day;
    const hasCompletePickup = Boolean(pickupDate && pickup.locationName);

    const completeEls = pickupInfoEl.querySelectorAll('.cart-pickup-info__complete');
    const incompleteEl = pickupInfoEl.querySelector('.cart-pickup-info__incomplete');

    completeEls.forEach((el) => {
      el.hidden = !hasCompletePickup;
    });
    if (incompleteEl) incompleteEl.hidden = hasCompletePickup;

    if (!hasCompletePickup) return;

    const dateEl = pickupInfoEl.querySelector('[data-pickup-date]');
    const locationEl = pickupInfoEl.querySelector('[data-pickup-location]');
    if (dateEl) dateEl.textContent = window.DateUtils.formatLong(pickupDate);
    if (locationEl) locationEl.textContent = pickup.locationName;
  }

  document.addEventListener('DOMContentLoaded', async function () {
    try {
      await clearInvalidPickup();
      await loadSavedPickupInfo();
    } catch (err) {
      console.error('Error loading pickup details:', err);
    }

    // Re-render the cart display + header handle whenever the selection changes.
    window.addEventListener('pickupSelectionChanged', function () {
      displayPickupInfo();
      renderPickupHandle();
    });

    // Initial render
    displayPickupInfo();
    renderPickupHandle();
  });
})();
